var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 11,
    viewBox: "0 0 100 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7090_1426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2181 9.75652V8.36957C10.2181 7.32696 9.75109 6.51391 8.9389 6.10261C9.76124 5.66739 10.2181 4.82087 10.2181 3.70653C10.2181 1.55435 8.78154 0.373047 6.17241 0.373047H0.0302734V10.8948H2.32469V7.13088H6.11657C7.37038 7.13088 7.90337 7.51827 7.90337 8.42218V9.76131C7.90337 10.1248 7.90337 10.5791 8.11657 10.8135L8.19271 10.8948H10.6648L10.3044 10.4978C10.213 10.3974 10.213 9.94783 10.213 9.75652H10.2181ZM2.32977 2.37218H6.02012C7.35515 2.37218 7.87291 2.74522 7.87291 3.69696C7.87291 4.90218 7.2587 5.13174 6.12164 5.13174H2.32977V2.37218Z",
    fill: "#253FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5277 0.373047L22.9287 10.8948H25.3805L26.1267 9.12522H31.6089L32.3703 10.8948H34.8373L30.2231 0.373047H27.5226H27.5277ZM30.7612 7.14044H26.9845L28.8729 2.72131L30.7612 7.14044Z",
    fill: "#253FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8884 0.373047H47.5889V10.8948H56.4721V8.89566H49.8884V0.373047Z",
    fill: "#253FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7104 0.373047H69.416V10.8948H78.2942V8.89566H71.7104V0.373047Z",
    fill: "#253FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2842 0.373047L94.0101 5.15566L90.7359 0.373047H88.0151L92.8679 7.21218V10.8948H95.1522V7.21218L99.9898 0.373047H97.2842Z",
    fill: "#253FF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7090_1426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04dd31567ee228d5f7329382407110ff.svg";
export { ForwardRef as ReactComponent };